import { render, staticRenderFns } from "./CompNameInfo.vue?vue&type=template&id=5ce7dc9f&scoped=true&"
import script from "./CompNameInfo.vue?vue&type=script&lang=js&"
export * from "./CompNameInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce7dc9f",
  null
  
)

export default component.exports